// src/components/results/mapLCW.js
import React, {
  useMemo, useState, useCallback, useContext, useEffect, useRef
} from "react";
import { GoogleMap, Marker, InfoWindow, useLoadScript } from "@react-google-maps/api";
import AuthContext from "../../Context/AuthContext";

export default function MobilityMap({
  rawData = [],
  centerFallback = { lat: 41.04, lng: 28.99 },
  zoom = 12,
}) {
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  });
  const { userData } = useContext(AuthContext);

  const sestoColor = {
    "A": "red",
    "B": "blue",
    "C": "purple",
    "Bağdat Caddesi": "green",
    "Kent Vizyon": "yellow",
    "Panout Otobüs Durağı": "orange",
    "Urban CLP": "pink",
    "Urban Metrobus": "red",
    "YOVI Megalight": "blue",
    "YOVI ONTV": "pink",
    "Bayi": "darkblue",
    "Sanayi Bölgesi": "darkgreen",
    "Araç Muayene İstasyonu": "orange",
  };

  const STORE_SVG_DATA_URL = 
   "data:image/svg+xml;charset=UTF-8," +
    encodeURIComponent(`
     <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 40 26" fill="none">
<path d="M19.9994 0C8.95377 0 0 5.82069 0 13.0006C0 20.1806 8.95377 26 19.9994 26C31.045 26 40 20.1793 40 13.0006C40 5.82196 31.045 0 19.9994 0ZM19.9994 20.4194C18.3562 20.4194 17.0165 17.1686 16.9305 13.0769C17.9202 13.1671 18.9528 13.2141 19.9994 13.2141C21.0459 13.2141 22.0786 13.1671 23.0695 13.0769C22.9823 17.1686 21.6412 20.4194 19.9994 20.4194ZM17.1353 9.83114C17.5827 6.93858 18.6962 4.88953 19.9994 4.88953C21.3025 4.88953 22.4173 6.93858 22.8647 9.83114C21.9484 9.91372 20.989 9.95818 19.9994 9.95818C19.0097 9.95818 18.0516 9.90863 17.1353 9.83114ZM19.9994 1.88264C17.8507 1.88264 16.0255 5.1093 15.3506 9.61138C11.2832 8.97621 8.44314 7.52294 8.44314 5.83593C8.44314 3.55695 13.6177 1.71496 19.9994 1.71496C26.381 1.71496 31.5556 3.55695 31.5556 5.83593C31.5556 7.52294 28.7168 8.9724 24.6494 9.61138C23.9745 5.1093 22.1468 1.88264 19.9994 1.88264ZM2.86789 12.5128C2.86789 10.3088 3.71094 8.24449 5.1809 6.46856C5.16404 6.59489 5.1556 6.7222 5.15562 6.84966C5.15562 9.62662 9.29883 11.9894 15.0776 12.8596C15.0776 13.0616 15.0776 13.2649 15.0776 13.4694C15.0776 18.6422 16.521 23.0223 18.513 24.5086C9.74374 23.9725 2.86789 18.801 2.86789 12.5128ZM21.487 24.5035C23.4803 23.0172 24.9237 18.6371 24.9237 13.4643C24.9237 13.2598 24.9237 13.0565 24.9237 12.8545C30.7024 11.9844 34.8456 9.62154 34.8456 6.84458C34.8459 6.71707 34.837 6.58971 34.8191 6.46348C36.2903 8.24195 37.1334 10.3037 37.1334 12.5077C37.1321 18.801 30.255 23.9725 21.487 24.5035Z" fill="#282830"/>
</svg>

    `);;

  const WEDDING_HALL_SVG_DATA_URL =
    "data:image/svg+xml;charset=UTF-8," +
    encodeURIComponent(`
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-label="Düğün salonu">
  <path d="M3 10l9-6 9 6"/>
  <path d="M5 10v10h14V10"/>
  <rect x="9" y="14" width="6" height="6" rx="1"/>
  <path d="M12 9.6c-.9-1.2-3-1-3 .9 0 1.2 1.2 2.3 3 3 1.8-.7 3-1.8 3-3 0-1.9-2.1-2.1-3-.9z" fill="currentColor" stroke="none"/>
</svg>

    `);

  const MARRIAGE_HALL_SVG_DATA_URL =
    "data:image/svg+xml;charset=UTF-8," +
    encodeURIComponent(`
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000" height="800px" width="800px" version="1.1" id="Layer_1" viewBox="0 0 435.729 435.729" xml:space="preserve">
<g>
	<path d="M175.622,47.125c0-26.027-21.473-47.125-47.5-47.125s-47.5,21.099-47.5,47.125v24.333h95V47.125z"/>
	<circle cx="338.583" cy="35.494" r="35.494"/>
	<polygon points="353.743,101.729 353.743,141.729 323.743,141.729 323.743,101.729 265.743,101.729 265.743,269.729    284.743,269.729 284.743,435.729 392.743,435.729 392.743,269.729 411.743,269.729 411.743,101.729  "/>
	<polygon points="172.26,191.729 184.435,101.729 72.264,101.729 84.44,191.729  "/>
	<polygon points="82.345,221.729 23.986,435.729 232.714,435.729 174.354,221.729  "/>
</g>
</svg>
    `);

  const REAL_ESTATE_SVG_DATA_URL =
    "data:image/svg+xml;charset=UTF-8," +
    encodeURIComponent(`
     <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000" height="800px" width="800px" version="1.1" id="Layer_1" viewBox="0 0 512 512" xml:space="preserve">
<g>
	<g>
		<path d="M256,1.468L0,254.587h39.984v255.945h432.033V254.587H512L256,1.468z M441.78,480.294H70.221V227.679L256,43.99    l185.78,183.689V480.294z"/>
	</g>
</g>
<g>
	<g>
		<path d="M346.318,217.594C346.318,217.594,346.318,217.594,346.318,217.594c-6.617-6.619-15.415-10.263-24.772-10.263    c-9.358,0-18.156,3.645-24.772,10.262c-13.659,13.658-13.659,35.883,0,49.543c6.83,6.83,15.801,10.244,24.771,10.244    c8.972,0,17.943-3.415,24.772-10.244C359.977,253.477,359.977,231.252,346.318,217.594z M324.937,245.755    c-1.869,1.869-4.912,1.871-6.782,0c-1.869-1.87-1.869-4.911,0.001-6.782c1.222-1.222,2.649-1.404,3.391-1.404    c0.742,0,2.169,0.182,3.39,1.403l0.001,0.001C326.805,240.843,326.805,243.885,324.937,245.755z"/>
	</g>
</g>
<g>
	<g>
		<path d="M372.925,190.986c-16.541-16.541-38.531-25.649-61.923-25.649c-23.391,0-45.382,9.108-61.922,25.649    c-23.247,23.245-31.305,57.68-21.525,88.51L112.099,394.953l8.586,41.855l31.637,31.637l132.092-132.091    c30.827,9.778,65.264,1.72,88.51-21.525C407.069,280.686,407.069,225.13,372.925,190.986z M351.544,293.449    c-16.907,16.905-42.848,21.544-64.551,11.543l-9.568-4.41L152.323,425.684l-3.841-3.841l-3.491-17.02l118.338-118.337l-4.41-9.568    c-10.001-21.705-5.363-47.647,11.543-64.551c10.829-10.829,25.228-16.793,40.541-16.793c15.315,0,29.713,5.964,40.542,16.793    C373.899,234.72,373.899,271.093,351.544,293.449z"/>
	</g>
</g>
</svg>
    `);
  const FIZIK_SVG_DATA_URL =
    "data:image/svg+xml;charset=UTF-8," +
    encodeURIComponent(`
     <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="800px" height="800px" viewBox="0 0 64 64" aria-hidden="true" role="img" class="iconify iconify--medical-icon" preserveAspectRatio="xMidYMid meet"><path d="M30.827 19.223a5.887 5.887 0 0 0 5.892-5.881a5.884 5.884 0 0 0-5.892-5.879c-3.255 0-5.893 2.632-5.893 5.879a5.889 5.889 0 0 0 5.893 5.881z" fill="#000000"/><path d="M48.78 58.98H1.806c-1.323 0-1.187 1.04-1.187 1.04v1.731S.499 64 2.809 64h58.817c2.325 0 2.199-2.197 2.199-2.197v-4.794s-.197-1.516-1.98-1.516h-5.732c-1.965 0-3.589 3.486-7.332 3.486z" fill="#000000"/><path d="M53.348 48.358c0 2.922 2.378 5.295 5.308 5.295c2.929 0 5.313-2.374 5.313-5.295c0-2.933-2.384-5.297-5.313-5.297a5.298 5.298 0 0 0-5.308 5.297z" fill="#000000"/><path d="M35.997 38.255a3.77 3.77 0 0 1-2.269 2.36l-4.727 1.753l1.744 1.731h7.98l-.005-12.215l-2.671 6.297c-.013.03-.037.047-.053.074z" fill="#000000"/><path d="M47.458 47.001h-16.5l-3.978-3.884l-2.769 1.02c-2.054.735-4.555-.387-5.326-2.428c-.454-1.267-.391-2.682.367-3.713c-.339-.015-10.007 0-10.007 0a2.906 2.906 0 0 0-2.915 2.898c0 1.607 1.307 2.863 2.915 2.863h9.843l3.903 5.909L2.84 51.285a2.909 2.909 0 0 0 .651 5.745l22.609.003a4.133 4.133 0 0 1-.629-2.177a4.176 4.176 0 0 1 4.173-4.173h9.046l7.331-1.531l.407 1.947l-7.533 1.573h-9.252a2.18 2.18 0 0 0-.044 4.361l17.898.002a5.014 5.014 0 0 0 4.992-5.013A5.023 5.023 0 0 0 47.458 47z" fill="#000000"/><path d="M23.862 42.315a2.309 2.309 0 0 1-3.038-1.185a2.303 2.303 0 0 1 1.187-3.04l8.401-3.154l2.596-6.192l-1.692-.625l-2.207 5.302l-6.395 2.355v-6.482l-6.251 6.827l-7.074-.007s12.379-13.57 12.766-13.976c.513-.509 1.686-1.353 3.898-1.353h7.949c4.516 0 5.385 4.502 4.461 6.832l-4.157 10.082a2.344 2.344 0 0 1-1.338 1.261l-9.106 3.353z" fill="#000000"/></svg>
    `);

  const UNIVERSITY_SVG_DATA_URL =
    "data:image/svg+xml;charset=UTF-8," +
    encodeURIComponent(`
      <svg xmlns="http://www.w3.org/2000/svg" fill="#000000" width="800px" height="800px" viewBox="0 0 16 16"><path d="M16 6.28a1.23 1.23 0 0 0-.62-1.07l-6.74-4a1.27 1.27 0 0 0-1.28 0l-6.75 4a1.25 1.25 0 0 0 0 2.15l1.92 1.12v2.81a1.28 1.28 0 0 0 .62 1.09l4.25 2.45a1.28 1.28 0 0 0 1.24 0l4.25-2.45a1.28 1.28 0 0 0 .62-1.09V8.45l1.24-.73v2.72H16V6.28zm-3.73 5L8 13.74l-4.22-2.45V9.22l3.58 2.13a1.29 1.29 0 0 0 1.28 0l3.62-2.16zM8 10.27l-6.75-4L8 2.26l6.75 4z"/></svg>
    `);

  const COMPETITOR_SVG_DATA_URL =
    "data:image/svg+xml;charset=UTF-8," +
    encodeURIComponent(`
     <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24">
        <path fill="#555" d="M3 9h18v13H3z"/>
        <path fill="#777" d="M2 8l2-4h16l2 4z"/>
        <rect x="8" y="13" width="8" height="9" fill="#999"/>
        <rect x="10" y="15" width="4" height="4" fill="#555"/>
      </svg>
      `);

  // LCW.JSON kategorileri için custom SVG ikonlar
  const BAGDAT_CADDESI_SVG = "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(`
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <circle cx="16" cy="16" r="14" fill="#00CED1" stroke="white" stroke-width="2"/>
      <path d="M16 8v16M8 16h16" stroke="white" stroke-width="2" stroke-linecap="round"/>
    </svg>
  `);

  const KENT_VIZYON_SVG = "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(`
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <circle cx="16" cy="16" r="14" fill="#FF1493" stroke="white" stroke-width="2"/>
      <rect x="10" y="10" width="12" height="12" fill="white" rx="2"/>
      <circle cx="16" cy="16" r="3" fill="#FF1493"/>
    </svg>
  `);

  const PANOUT_SVG = "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(`
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <circle cx="16" cy="16" r="14" fill="#1E90FF" stroke="white" stroke-width="2"/>
      <rect x="8" y="10" width="16" height="12" rx="2" fill="white"/>
      <circle cx="12" cy="22" r="2" fill="#1E90FF"/>
      <circle cx="20" cy="22" r="2" fill="#1E90FF"/>
    </svg>
  `);

  const URBAN_CLP_SVG = "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(`
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <circle cx="16" cy="16" r="14" fill="#32CD32" stroke="white" stroke-width="2"/>
      <rect x="9" y="9" width="14" height="14" fill="white" rx="1"/>
      <path d="M13 16h6M16 13v6" stroke="#32CD32" stroke-width="1.5"/>
    </svg>
  `);

  const URBAN_METROBUS_SVG = "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(`
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <circle cx="16" cy="16" r="14" fill="#FFD700" stroke="white" stroke-width="2"/>
      <rect x="8" y="10" width="16" height="12" rx="2" fill="white"/>
      <rect x="10" y="12" width="3" height="3" fill="#FFD700"/>
      <rect x="14" y="12" width="3" height="3" fill="#FFD700"/>
      <rect x="18" y="12" width="3" height="3" fill="#FFD700"/>
      <circle cx="11" cy="23" r="1.5" fill="#FFD700"/>
      <circle cx="21" cy="23" r="1.5" fill="#FFD700"/>
    </svg>
  `);

  const YOVI_MEGALIGHT_SVG = "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(`
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <circle cx="16" cy="16" r="14" fill="#FF4500" stroke="white" stroke-width="2"/>
      <polygon points="16,9 20,15 18,15 22,22 14,22 18,15 16,15" fill="white"/>
    </svg>
  `);

  const YOVI_ONTV_SVG = "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(`
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <circle cx="16" cy="16" r="14" fill="#FF69B4" stroke="white" stroke-width="2"/>
      <rect x="10" y="10" width="12" height="11" fill="white" rx="1"/>
      <polygon points="16,22 14,25 18,25" fill="#FF69B4"/>
    </svg>
  `);

  const TOYOTA_BAYI_SVG = "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(`
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="26" viewBox="0 0 40 26" fill="none">
<path d="M19.9994 0C8.95377 0 0 5.82069 0 13.0006C0 20.1806 8.95377 26 19.9994 26C31.045 26 40 20.1793 40 13.0006C40 5.82196 31.045 0 19.9994 0ZM19.9994 20.4194C18.3562 20.4194 17.0165 17.1686 16.9305 13.0769C17.9202 13.1671 18.9528 13.2141 19.9994 13.2141C21.0459 13.2141 22.0786 13.1671 23.0695 13.0769C22.9823 17.1686 21.6412 20.4194 19.9994 20.4194ZM17.1353 9.83114C17.5827 6.93858 18.6962 4.88953 19.9994 4.88953C21.3025 4.88953 22.4173 6.93858 22.8647 9.83114C21.9484 9.91372 20.989 9.95818 19.9994 9.95818C19.0097 9.95818 18.0516 9.90863 17.1353 9.83114ZM19.9994 1.88264C17.8507 1.88264 16.0255 5.1093 15.3506 9.61138C11.2832 8.97621 8.44314 7.52294 8.44314 5.83593C8.44314 3.55695 13.6177 1.71496 19.9994 1.71496C26.381 1.71496 31.5556 3.55695 31.5556 5.83593C31.5556 7.52294 28.7168 8.9724 24.6494 9.61138C23.9745 5.1093 22.1468 1.88264 19.9994 1.88264ZM2.86789 12.5128C2.86789 10.3088 3.71094 8.24449 5.1809 6.46856C5.16404 6.59489 5.1556 6.7222 5.15562 6.84966C5.15562 9.62662 9.29883 11.9894 15.0776 12.8596C15.0776 13.0616 15.0776 13.2649 15.0776 13.4694C15.0776 18.6422 16.521 23.0223 18.513 24.5086C9.74374 23.9725 2.86789 18.801 2.86789 12.5128ZM21.487 24.5035C23.4803 23.0172 24.9237 18.6371 24.9237 13.4643C24.9237 13.2598 24.9237 13.0565 24.9237 12.8545C30.7024 11.9844 34.8456 9.62154 34.8456 6.84458C34.8459 6.71707 34.837 6.58971 34.8191 6.46348C36.2903 8.24195 37.1334 10.3037 37.1334 12.5077C37.1321 18.801 30.255 23.9725 21.487 24.5035Z" fill="#282830"/>
</svg>
  `);

  const TOYOTA_SANAYI_SVG = "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(`
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000" height="800px" width="800px" version="1.1" id="Capa_1" viewBox="0 0 455.5 455.5" xml:space="preserve"><script xmlns="" id="datalayer-checker-script"/>
<g>
	<path d="M447.75,391.763v-95.308c2.483-0.123,4.779-1.381,6.197-3.441c1.492-2.169,1.822-4.934,0.881-7.394l-15.25-39.854   c-1.185-3.096-4.156-5.141-7.472-5.141H319.25V80.875c0-4.418-3.582-8-8-8H207.542c-4.418,0-8,3.582-8,8v79.646h-39.275V55.75   c0-4.418-3.582-8-8-8h-32.008c-4.418,0-8,3.582-8,8v104.771H96.25V55.75c0-4.418-3.582-8-8-8H56.241c-4.418,0-8,3.582-8,8v104.771   H23.625c-3.315,0-6.287,2.045-7.472,5.141l-15.25,39.854c-0.941,2.459-0.611,5.224,0.881,7.394   c1.422,2.065,3.726,3.325,6.216,3.442V391.75c-4.418,0-8,3.582-8,8s3.582,8,8,8h8h191.542h104.875H439.75h7.75c4.418,0,8-3.582,8-8   C455.5,395.416,452.051,391.896,447.75,391.763z M128.259,95.875h16.008v64.333h-16.008V95.875z M144.267,63.75v16.125h-16.008   V63.75H144.267z M64.241,95.875H80.25v64.333H64.241V95.875z M80.25,63.75v16.125H64.241V63.75H80.25z M426.602,256.625   l9.128,23.854h-3.623H319.25v-23.854H426.602z M215.542,88.875h87.708V391.75h-87.708V208.208V88.875z M135.896,216.208v47.5   h-48.25v-47.5H135.896z M199.542,216.208v47.5h-47.646v-47.5H199.542z M199.542,327.958h-47.646v-48.25h47.646V327.958z    M71.646,263.708H24v-47.352c0.426-0.02,0.846-0.064,1.253-0.148h46.393V263.708z M24,279.708h47.646v48.25H24V279.708z    M87.646,279.708h48.25v48.25h-48.25V279.708z M135.896,343.958v47.792h-48.25v-47.792H135.896z M151.896,343.958h47.646v47.792   h-47.646V343.958z M29.13,176.521h170.412v23.688h-54.143c-0.488-0.093-0.989-0.146-1.504-0.146s-1.016,0.053-1.504,0.146H81.149   c-0.488-0.093-0.989-0.146-1.504-0.146s-1.016,0.053-1.504,0.146H20.066L29.13,176.521z M24,343.958h47.646v47.792H24V343.958z    M399.5,391.75h-48.167v-39.708H399.5V391.75z M415.5,391.75v-47.708c0-4.418-3.582-8-8-8h-64.167c-4.418,0-8,3.582-8,8v47.708   h-14.916v-95.271H431.75v95.271H415.5z"/>
	<path d="M248.208,144.5c4.418,0,8-3.582,8-8v-15.75c0-4.418-3.582-8-8-8s-8,3.582-8,8v15.75   C240.208,140.918,243.79,144.5,248.208,144.5z"/>
	<path d="M271.75,144.5c4.418,0,8-3.582,8-8v-15.75c0-4.418-3.582-8-8-8s-8,3.582-8,8v15.75   C263.75,140.918,267.332,144.5,271.75,144.5z"/>
	<path d="M248.208,200.99c4.418,0,8-3.582,8-8v-15.75c0-4.418-3.582-8-8-8s-8,3.582-8,8v15.75   C240.208,197.408,243.79,200.99,248.208,200.99z"/>
	<path d="M271.75,200.99c4.418,0,8-3.582,8-8v-15.75c0-4.418-3.582-8-8-8s-8,3.582-8,8v15.75   C263.75,197.408,267.332,200.99,271.75,200.99z"/>
	<path d="M248.208,256.625c4.418,0,8-3.582,8-8v-15.75c0-4.418-3.582-8-8-8s-8,3.582-8,8v15.75   C240.208,253.043,243.79,256.625,248.208,256.625z"/>
	<path d="M271.75,256.625c4.418,0,8-3.582,8-8v-15.75c0-4.418-3.582-8-8-8s-8,3.582-8,8v15.75   C263.75,253.043,267.332,256.625,271.75,256.625z"/>
	<path d="M248.208,313.115c4.418,0,8-3.582,8-8v-15.75c0-4.418-3.582-8-8-8s-8,3.582-8,8v15.75   C240.208,309.533,243.79,313.115,248.208,313.115z"/>
	<path d="M271.75,313.115c4.418,0,8-3.582,8-8v-15.75c0-4.418-3.582-8-8-8s-8,3.582-8,8v15.75   C263.75,309.533,267.332,313.115,271.75,313.115z"/>
	<path d="M248.208,368.781c4.418,0,8-3.582,8-8v-15.75c0-4.418-3.582-8-8-8s-8,3.582-8,8v15.75   C240.208,365.2,243.79,368.781,248.208,368.781z"/>
	<path d="M271.75,368.781c4.418,0,8-3.582,8-8v-15.75c0-4.418-3.582-8-8-8s-8,3.582-8,8v15.75   C263.75,365.2,267.332,368.781,271.75,368.781z"/>
</g>
<script xmlns=""/><script xmlns=""/></svg>
  `);

  const TOYOTA_MUAYENE_SVG = "https://uxwing.com/wp-content/themes/uxwing/download/transportation-automotive/car-inspection-icon.png";

  // ---- Noktalar
  const points = useMemo(() => {
    const norm = (v) => (typeof v === "string" ? v.replace(/\s+/g, " ").trim() : v) || null;
    return (Array.isArray(rawData) ? rawData : [])
      .map((r, idx) => {
        const lat = Number(String(r.latitude).replace(",", "."));
        const lng = Number(String(r.longitude).replace(",", "."));
        const type = norm(r["Liste Tür"] ?? r["Liste  Tür"] ?? null);
        const ses = norm(r["SES"]) || type || (type === "Mağaza" ? "Mağaza" : "Diğer");
        const colorName = (ses && sestoColor[ses]) || "red";

        // Toyota verileri için başlık belirle
        let title;
        if (r["Bayi"]) {
          title = r["Bayi"];
        } else if (r["Sanayi Bölgesi"]) {
          title = r["Sanayi Bölgesi"];
        } else if (r["Araç Muayene İstasyonu"]) {
          title = r["Araç Muayene İstasyonu"];
        } else {
          title = r["Adres"] || type || `Konum #${idx + 1}`;
        }

        return {
          id: `p${idx + 1}`,
          lat: Number.isFinite(lat) ? lat : null,
          lng: Number.isFinite(lng) ? lng : null,
          title,
          address: r["Adres"] || null,
          type,
          ses,
          colorName,
          raw: r,
        };
      })
      .filter((p) => Number.isFinite(p.lat) && Number.isFinite(p.lng));
  }, [rawData]);

  // ---- Başlangıç merkezi
  const initialCenter = useMemo(() => {
    if (!points.length) return centerFallback;
    const sum = points.reduce((acc, p) => ({ lat: acc.lat + p.lat, lng: acc.lng + p.lng }), { lat: 0, lng: 0 });
    return { lat: sum.lat / points.length, lng: sum.lng / points.length };
  }, [points, centerFallback]);

  // ---- Controlled center: sadece ilk kez set et
  const [mapCenter, setMapCenter] = useState(initialCenter);
  const [didCenterOnce, setDidCenterOnce] = useState(false);
  const mapRef = useRef(null);
  const [active, setActive] = useState(null);

  useEffect(() => {
    if (!didCenterOnce) {
      setMapCenter(initialCenter);
      setDidCenterOnce(true);
    }
  }, [initialCenter, didCenterOnce]);

  const onLoad = useCallback((map) => (mapRef.current = map), []);
  const onDragEnd = useCallback(() => {
    if (mapRef.current) setMapCenter(mapRef.current.getCenter().toJSON());
  }, []);

  // ---- Legend + Filtre (SES bazlı)
  const allSES = useMemo(
    () => Array.from(new Set(points.map((p) => p.ses).filter(Boolean))).sort(),
    [points]
  );
  const [visibleSES, setVisibleSES] = useState(() => new Set(allSES)); // hepsi açık başla

  // allSES değişirse (data güncellenirse) görünürlüğü senkronla
  useEffect(() => {
    setVisibleSES((prev) => {
      const next = new Set(prev);
      allSES.forEach((t) => next.add(t));
      // var olmayanları çıkar
      for (const t of Array.from(next)) if (!allSES.includes(t)) next.delete(t);
      return next;
    });
  }, [allSES]);

  const toggleSES = (t) =>
    setVisibleSES((s) => {
      const n = new Set(s);
      n.has(t) ? n.delete(t) : n.add(t);
      return n;
    });

  const setAll = (on) => setVisibleSES(new Set(on ? allSES : []));

  // Legend sırası: Toyota -> Bellona -> LCW
  const legendOrder = [
    "Bayi", "Sanayi Bölgesi", "Araç Muayene İstasyonu",
    "Mağaza", "Düğün Salonu", "Nikah Salonu", "Emlak Ofisi", "Üniversite", "Fizik Tedavi Merkezi", "Rakip Mağazalar",
    "Bağdat Caddesi", "Kent Vizyon", "Panout Otobüs Durağı", "Urban CLP", "Urban Metrobus", "YOVI Megalight", "YOVI ONTV"
  ];

  const labelDisplayMap = {
    "Bayi": "Toyota Bayileri",
    "Sanayi Bölgesi": "Sanayi Bölgeleri",
    "Araç Muayene İstasyonu": "Araç Muayene İstasyonları",
    "Mağaza": "Bellona Mağazaları",
    "Panout Otobüs Durağı": "Panout Otobüs Durağı",
    "Urban CLP": "Urban CLP",
    "Bağdat Caddesi": "Bağdat Caddesi",
    "Kent Vizyon": "Kent Vizyon",
    "Urban Metrobus": "Urban Metrobus",
    "YOVI Megalight": "YOVI Megalight",
    "YOVI ONTV": "YOVI ONTV"
  };

  const legendItems = useMemo(
    () => {
      // allSES'i legendOrder'a göre sırala
      const sortedSES = legendOrder.filter(item => allSES.includes(item));

      return sortedSES.map((label) => {
        const color = sestoColor[label] || "red";
        let iconSrc;
        switch (label) {
          case "Mağaza":
            iconSrc = STORE_SVG_DATA_URL;
            break;
          case "Düğün Salonu":
            iconSrc = WEDDING_HALL_SVG_DATA_URL;
            break;
          case "Nikah Salonu":
            iconSrc = MARRIAGE_HALL_SVG_DATA_URL;
            break;
          case "Emlak Ofisi":
            iconSrc = REAL_ESTATE_SVG_DATA_URL;
            break;
          case "Üniversite":
            iconSrc = UNIVERSITY_SVG_DATA_URL;
            break;
          case "Fizik Tedavi Merkezi":
            iconSrc = FIZIK_SVG_DATA_URL;
            break;
          case "Rakip Mağazalar":
            iconSrc = COMPETITOR_SVG_DATA_URL;
            break;
          case "Bayi":
            iconSrc = TOYOTA_BAYI_SVG;
            break;
          case "Sanayi Bölgesi":
            iconSrc = TOYOTA_SANAYI_SVG;
            break;
          case "Araç Muayene İstasyonu":
            iconSrc = TOYOTA_MUAYENE_SVG;
            break;
          case "Urban Metrobus":
          case "YOVI Megalight":
          case "YOVI ONTV":
            // Renk noktaları
            iconSrc = `https://maps.google.com/mapfiles/ms/icons/${color}-dot.png`;
            break;

          default:
            // A, B, C için Google Maps renkli noktaları
            iconSrc = `https://maps.google.com/mapfiles/ms/icons/${color}-dot.png`;
        }
        const displayLabel = labelDisplayMap[label] || label;
        return { label, displayLabel, iconSrc, checked: visibleSES.has(label) };
      });
    },
    [allSES, visibleSES, legendOrder]
  );

  if (loadError) return <div style={{ padding: 12, color: "#b00020" }}>Harita yüklenirken hata: {String(loadError.message || loadError)}</div>;
  if (!isLoaded) return <div>Harita yükleniyor…</div>;

  // ---- InfoWindow stilleri
  const cardStyle = { maxWidth: 260, display: "grid", gap: 8, fontFamily: "system-ui,-apple-system,Segoe UI,Roboto,Helvetica,Arial,sans-serif" };
  const titleStyle = { margin: 0, fontSize: 16, fontWeight: 600 };
  const metaStyle = { margin: 0, fontSize: 13, lineHeight: 1.4, opacity: 0.9 };
  const infoOpts = { maxWidth: 280, pixelOffset: new window.google.maps.Size(0, -8) };

  const getMarkerIcon = (colorName, ses) => {
    let iconUrl;
    switch (ses) {
      case "Mağaza":
        iconUrl = STORE_SVG_DATA_URL;
        break;
      case "Düğün Salonu":
        iconUrl = WEDDING_HALL_SVG_DATA_URL;
        break;
      case "Nikah Salonu":
        iconUrl = MARRIAGE_HALL_SVG_DATA_URL;
        break;
      case "Emlak Ofisi":
        iconUrl = REAL_ESTATE_SVG_DATA_URL;
        break;
      case "Üniversite":
        iconUrl = UNIVERSITY_SVG_DATA_URL;
        break;
      case "Fizik Tedavi Merkezi":
        iconUrl = FIZIK_SVG_DATA_URL;
        break;
      case "Rakip Mağazalar":
        iconUrl = COMPETITOR_SVG_DATA_URL;
        break;
      case "Bayi":
        iconUrl = TOYOTA_BAYI_SVG;
        break;
      case "Sanayi Bölgesi":
        iconUrl = TOYOTA_SANAYI_SVG;
        break;
      case "Araç Muayene İstasyonu":
        iconUrl = TOYOTA_MUAYENE_SVG;
        break;
      case "Urban Metrobus":
      case "YOVI Megalight":
      case "YOVI ONTV":
        // Renk noktaları
        return `https://maps.google.com/mapfiles/ms/icons/${colorName}-dot.png`;
      default:
        // A, B, C için Google Maps renkli noktaları kullan
        return `https://maps.google.com/mapfiles/ms/icons/${colorName}-dot.png`;
    }
    return { url: iconUrl, scaledSize: new window.google.maps.Size(32, 32), anchor: new window.google.maps.Point(16, 32) };
  };

  // ---- Filtre uygulanmış noktalar
  const visiblePoints = points.filter((p) => !p.ses || visibleSES.has(p.ses));

  return (
    <div style={{ height: "100vh", width: "100%" }}>
      <div
        style={{
          height: "800px",
          width: "80%",
          margin: "40px auto",
          borderRadius: 8,
          overflow: "hidden",
          boxShadow: "0 2px 10px rgba(0,0,0,.2)",
          position: "relative",
        }}
      >
        <GoogleMap
          center={mapCenter}
          zoom={zoom}
          onLoad={onLoad}
          onDragEnd={onDragEnd}
          mapContainerStyle={{ height: "100%", width: "100%" }}
          options={{ gestureHandling: "greedy" }}
        >
          {visiblePoints.map((p) => (
            <Marker
              key={p.id}
              position={{ lat: p.lat, lng: p.lng }}
              onClick={() => setActive(p)}
              icon={getMarkerIcon(p.colorName, p.ses)}
            />
          ))}

          {active && (
            <InfoWindow position={{ lat: active.lat, lng: active.lng }} onCloseClick={() => setActive(null)} options={infoOpts}>
              <div style={cardStyle}>
                <h3 style={titleStyle}>{active.raw["İsim"] || active.raw["Bayi"] || active.raw["Sanayi Bölgesi"] || active.raw["Araç Muayene İstasyonu"] || active.title}</h3>
                {active.address && (
                  <p style={metaStyle}>
                    <strong>Adres:</strong> {active.address}
                  </p>
                )}
                {active.raw["POI Tipi"] && (
                  <p style={metaStyle}>
                    <strong>POI Tipi:</strong> {active.raw["POI Tipi"]}
                  </p>
                )}
                {active.type && (
                  <p style={metaStyle}>
                    <strong>Liste Tür:</strong> {active.type}
                  </p>
                )}
                {active.ses && (
                  <p style={metaStyle}>
                    <strong>Kategori:</strong> {active.ses}
                  </p>
                )}
              </div>
            </InfoWindow>
          )}
        </GoogleMap>

        {/* Legend + Filtre */}
        <div
          style={{
            position: "absolute",
            left: 12,
            bottom: 12,
            background: "rgba(255,255,255,.95)",
            padding: "10px 12px",
            borderRadius: 8,
            boxShadow: "0 1px 6px rgba(0,0,0,.2)",
            fontSize: 13,
            minWidth: 210,
          }}
        >
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 6 }}>
            {/* <div style={{ fontWeight: 600 }}>Katman Renkleri</div> */}
            <div style={{ display: "flex", gap: 6 }}>
              <button onClick={() => setAll(true)} style={{ fontSize: 12, padding: "2px 6px", border: "1px solid #ddd", borderRadius: 6, background: "#fff" }}>
                Tümünü Aç
              </button>
              <button onClick={() => setAll(false)} style={{ fontSize: 12, padding: "2px 6px", border: "1px solid #ddd", borderRadius: 6, background: "#fff" }}>
                Kapat
              </button>
            </div>
          </div>

          {legendItems.map((it) => (
            <label key={it.label} style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 6, cursor: "pointer" }}>
              <input
                type="checkbox"
                checked={it.checked}
                onChange={() => toggleSES(it.label)}
                style={{ margin: 0 }}
              />
              <img alt={it.label} width={18} height={18} src={it.iconSrc} />
              <span>{it.displayLabel}</span>
            </label>
          ))}
        </div>
      </div>
    </div>
  );
}
